module.exports = __webpack_public_path__ + "assets/b5b5e29221434564421bbf3149ed0141.png";